/**
 * ZooRoyal Button.
 */
@use '../zr-theme/functions/fonts' as f;
@use '../zr-theme/zr-variables.scss' as *;
@use "../zr-css-icon/zr-css-icon.scss" as i;
@use '../zr-theme/zr-theme.scss';

$component: 'zr-modal';

.#{$component} {
    padding: 0;
    background-color: var(--ci-neutral100);
    border: none;
    text-align: center;
    width: 100vw;
    height: 100dvh;
    max-height: none;
    max-width: none;
    outline: none;

    &::backdrop{
        background: rgba(51 51 51 / 80%);
    }

    @media only screen and (min-width: 600px) {
        width: var(--zr-modal-width, 400px);
        height: max-content;
        max-height: 90vh;
        border-radius: 8px;
        box-shadow: 0 2px 35px #000;

        &.zr-modal--large {
            width: 600px;
        }
    }
}

.#{$component}__inner{
    padding: 16px;
}

.#{$component} h2 {
    margin-top: 0;
    margin-bottom: 12px;
    font-size: f.calc-em(20);
}

.#{$component}-content__wrapper {
    padding: 0 32px 32px;
}

.#{$component}-closing__tag {
    cursor: pointer;
    display: inline-block;
    margin-top: 10px;
    background: none;
    color: var(--ci-neutral800);
    text-decoration: none;
    font-weight: 600;
}

.#{$component}__close{
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    outline: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
    font-size: 0;

    @include i.get-icon-left(close);

    &::before {
        height: 16px;
        width: 16px;
    }

    &:focus-visible {
        outline: 2px solid var(--ci-primary600);
    }
}
